import {Component, OnInit} from '@angular/core';
import {GlobalIntegrationService} from '../../../shared/services/globalIntegration.service';
import {SimpleEventResource} from '../../../shared/models/resources/simpleEventResource.model';
import {SimpleQueryResponseResource} from '../../../shared/models/resources/simpleQueryResponseResource.model';
import {SimplePaginationResource} from '../../../shared/models/resources/simplePaginationResource.model';
import {Pagination} from '../../../shared/models';
import {CONFIG} from '../../../config';
import {JqueryCommonService} from '../../../shared/services/jquery-common.service';
import 'src/extensions';

@Component({
  standalone: false,
  selector: 'cci-result-panel',
  templateUrl: './result-panel.component.html',
  styleUrls: ['./result-panel.component.scss']
})
export class ResultPanelComponent implements OnInit {

  public static humanPropertyNames = new Map<string, string>();

  public results: SimpleEventResource[] = [];
  public pagination: SimplePaginationResource = new SimplePaginationResource();
  public rmsPagination: Pagination;
  public sortableProperties: string[] = [];

  private CCI_HEADER_SORTABLE_ICON_CLASS = 'cci-header-sortable-icon';
  private FA_BARS_CLASS = 'fa-bars';
  private FA_SORT_ASC_CLASS = 'fa-sort-asc';
  private FA_SORT_DESC_CLASS = 'fa-sort-desc';
  private CCI_HEADER_DATA_PROPERTY_KEY = 'cciPropertyKey';

  public ready = false;

  constructor(
    private globalIntegrationService: GlobalIntegrationService,
    private jqueryCommonService: JqueryCommonService,
  ) {
    this.rmsPagination = new Pagination(CONFIG.pagination);
    this.rmsPagination.sort = null;
    this.initHumanPropertyNames();
  }

  initHumanPropertyNames() {
    ResultPanelComponent.humanPropertyNames.set('sourceCalendar', 'Source Calendar');
    ResultPanelComponent.humanPropertyNames.set('labelledEventType', 'Type');
    ResultPanelComponent.humanPropertyNames.set('labelledCompany', 'Company');
    ResultPanelComponent.humanPropertyNames.set('extractedCompanyAttendees', 'Company Attendees');
    ResultPanelComponent.humanPropertyNames.set('simpleAttendees', 'Simple Attendees');
    ResultPanelComponent.humanPropertyNames.set('eventStatus', 'Status');
    ResultPanelComponent.humanPropertyNames.set('eventCreated', 'Created');
    ResultPanelComponent.humanPropertyNames.set('eventCreator', 'Creator');
    ResultPanelComponent.humanPropertyNames.set('eventOrganizer', 'Organizer');
    ResultPanelComponent.humanPropertyNames.set('eventAttendees', 'Attendees');
    ResultPanelComponent.humanPropertyNames.set('eventTitle', 'Title');
    ResultPanelComponent.humanPropertyNames.set('eventDescription', 'Description');
    ResultPanelComponent.humanPropertyNames.set('eventLocation', 'Location');
    ResultPanelComponent.humanPropertyNames.set('eventStart', 'Start');
    ResultPanelComponent.humanPropertyNames.set('eventEnd', 'End');
    ResultPanelComponent.humanPropertyNames.set('eventVisibility', 'Visibility');
    ResultPanelComponent.humanPropertyNames.set('eventAttachments', 'Attachments');

    // this.humanPropertyNames.set('eventId', 'ID');
  }

  ngOnInit() {
    this.globalIntegrationService.eventsQuerySearchEventEmitter.subscribe((result) => {
      console.warn(result);
      const resource = new SimpleQueryResponseResource(result);
      const pagination = resource.pagination;
      const sortableProperties = resource.sortableProperties;

      this.results = resource.events.map(event => new SimpleEventResource(event));
      this.pagination = pagination;
      this.rmsPagination.page = pagination.page;
      this.sortableProperties = sortableProperties;

      this.ready = true;
      if (result.resetSort) {
        this.resetSortIcon('');
      }
    });
  }

  properties() {
    return Array.from(ResultPanelComponent.humanPropertyNames.keys());
  }

  humanName(key: string) {
    if (ResultPanelComponent.humanPropertyNames.has(key)) {
      return ResultPanelComponent.humanPropertyNames.get(key);
    }
    return key;
  }

  safeValue(event, prop) {
    const val = event[prop];
    if (val === undefined) {
      throw Error('property ' + prop + ' is not present in event ' + event);
    }
    return val;
  }

  paginationChanged() {
    if (!this.ready) {
      return;
    }

    console.warn('paginate');
    this.globalIntegrationService.paginationChangeEventEmitter.next({
      page: this.rmsPagination.page,
      countPerPage: this.rmsPagination.pagesize,
    });
  }

  headerSortClickEventHandler(event: MouseEvent) {
    console.warn(event);
    const targetDiv = (event.target as any);
    if (targetDiv) {
      const headerString = targetDiv.dataset[this.CCI_HEADER_DATA_PROPERTY_KEY];
      this.resetSortIcon(headerString);
      if (this.checkIfHeaderSortable(headerString)) {
        const currentSortIconSelector = this.jqueryCommonService.selector(targetDiv).find(this.CCI_HEADER_SORTABLE_ICON_CLASS.toClass());
        this.getSortedCalendarData(headerString, currentSortIconSelector);
      }
    }
  }

  getSortedCalendarData(headerName: string, sortIconSelector: any) {
    const currentSortType = this.switchSortableIcon(sortIconSelector);
    this.globalIntegrationService.calendarHeaderSortChangeEventEmitter.next({
      sortFieldName: headerName,
      sortType: currentSortType
    });
  }

  switchSortableIcon(sortableIconSelector: any) {
    let sortType;
    if (sortableIconSelector.hasClass(this.FA_BARS_CLASS)) {
      sortableIconSelector.removeClass(this.FA_BARS_CLASS);
      sortableIconSelector.addClass(this.FA_SORT_ASC_CLASS);
      sortType = 'ASC';
    } else if (sortableIconSelector.hasClass(this.FA_SORT_ASC_CLASS)) {
      sortableIconSelector.removeClass(this.FA_SORT_ASC_CLASS);
      sortableIconSelector.addClass(this.FA_SORT_DESC_CLASS);
      sortType = 'DESC';
    } else if (sortableIconSelector.hasClass(this.FA_SORT_DESC_CLASS)) {
      sortableIconSelector.removeClass(this.FA_SORT_DESC_CLASS);
      sortableIconSelector.addClass(this.FA_BARS_CLASS);
      sortType = 'ASC';
    }
    return sortType;
  }

  resetSortIcon(headerString: string) {
    const allHeaderClass = this.jqueryCommonService.selector(this.CCI_HEADER_SORTABLE_ICON_CLASS.toClass());
    allHeaderClass.each((index, eachHeaderIconClass) => {
      const currentHeaderIconSelector = this.jqueryCommonService.selector(eachHeaderIconClass);
      const headerParentElement = (currentHeaderIconSelector.parent()[0] as any);
      const currentElementHeaderString = headerParentElement.dataset[this.CCI_HEADER_DATA_PROPERTY_KEY];
      if (currentElementHeaderString !== headerString) {
        currentHeaderIconSelector.removeClass(this.FA_BARS_CLASS)
          .removeClass(this.FA_SORT_ASC_CLASS)
          .removeClass(this.FA_SORT_DESC_CLASS);
        currentHeaderIconSelector.addClass(this.FA_BARS_CLASS);
      }
    });
  }

  checkIfHeaderSortable(headerName: string) {
    return this.sortableProperties.includes(headerName);
  }
}
